import React, { useState,useEffect, useRef  } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Password } from "primereact/password";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import { Toast } from 'primereact/toast';
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";

export default function PublicRequestMembership (props) {
    const toast = useRef(null);
    const [panelRequestVisible, setPanelRequestVisible] = useState(true);
    const [panelSavePasswoerdVisible, setPanelSavePasswoerdVisible] = useState(false);
    const [nationalId, setNationalId] = useState("");
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState();
    const [mobile, setMobile] = useState("");
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [smsCode, setSmsCode] = useState();
    

    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "nationalId") setNationalId(val);
        else if(name === "mobile") setMobile(val);
        else if(name === "firstname") setFirstname(val);
        else if(name === "lastname") setLastname(val);
        else if(name === "smsCode") setSmsCode(val);
    }
    const checkDataEntry = function(){    
        if(nationalId.trim().length == 0){
            setErrorMessage("کد ملی را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(mobile.trim().length == "" ){
            setErrorMessage("شماره تلفن را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(firstname.trim().length == "" ){
            setErrorMessage("نام را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(lastname.trim().length == "" ){
            setErrorMessage("نام خانوادگی را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(smsCode.trim().length == 0){
            setErrorMessage("کد پیامکی را وارد کنید");
            setErorVisible(true);
            return false;
        }
        return true;
    }
    const saveRequestMemberShip = function(){
        if(!checkDataEntry()) return;
        setSaving(true);
        var params = {nationalId:nationalId, mobile:mobile, firstname:firstname, lastname:lastname, smsCode:smsCode}
        var url = config.Server+`/user/public/membership/save`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    response = response.data;
                    console.log("response is>", response);
                    toast.current.show({ severity: 'info', summary: 'Info', detail: 'با موفقیت ثبت شد' });     
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                }
                setSaving(false);
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
            });
    }
    const codeRuquest = function(){
        setSaving(true);
        var params = {nationalId:nationalId, mobile:mobile}
        var url = config.Server+`/user/public/membership/request/code`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    response = response.data;
                    console.log("response is>", response);
                    toast.current.show({ severity: 'info', summary: 'Info', detail: 'ارسال شد' });                    
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                }
                setSaving(false);
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
            });
    }

    return(
        <>
        {
        (redirectUrl != "")
        ?
        <Navigate to={redirectUrl} replace={false}  />
        :
        (panelRequestVisible)? 
        <>  
        <div style={{width:"100%"}}>
            <div style={{width:"100%", padding:"5px 20px 20px 20px", height:"80vh", overflowY:"scroll"}}>
                <table style={{width:"100%", minWidth:"300px", maxWidth:"450px", marginLeft:"auto", marginRight:"auto"}}>
                    <tbody>
                        <tr>
                            <td style={{width:"100%", textAlign:"center"}}><span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user-plus"></span></td>
                        </tr>
                        <tr>
                            <td style={{fontSize:"1.5em", textAlign:"center"}}> درخواست عضویت معلم</td>
                        </tr>
                        <tr><td>&nbsp;</td></tr>
                        <tr>
                            <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                                <FloatLabel>
                                    <InputText value={nationalId} onChange={(e)=>{onInputChange(e, "nationalId")}} id="nationalId" keyfilter="int" maxLength={12} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                    <label htmlFor="username">کد ملی</label>
                                </FloatLabel>
                            </td>
                        </tr>
                        <tr><td>&nbsp;</td></tr>
                        <tr>
                            <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                                <FloatLabel>
                                    <InputText value={firstname} onChange={(e)=>{onInputChange(e, "firstname")}} id="firstname" keyfilter="" maxLength={25} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                    <label htmlFor="username">نام</label>
                                </FloatLabel>
                            </td>
                        </tr>
                        <tr><td>&nbsp;</td></tr>
                        <tr>
                            <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                                <FloatLabel>
                                    <InputText value={lastname} onChange={(e)=>{onInputChange(e, "lastname")}} id="lastname" keyfilter="" maxLength={25} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                    <label htmlFor="username">نام خانوادگی</label>
                                </FloatLabel>
                            </td>
                        </tr>
                        <tr><td>&nbsp;</td></tr>
                        <tr>
                            <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                                <FloatLabel>
                                    <InputText value={mobile} onChange={(e)=>{onInputChange(e, "mobile")}} id="mobile" keyfilter="int" maxLength={11} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                    <label htmlFor="username">موبایل</label>
                                </FloatLabel>
                            </td>
                        </tr>
                        <tr><td>&nbsp;</td></tr>
                        <tr>
                            <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                                <FloatLabel>
                                    <InputText value={smsCode} onChange={(e)=>{onInputChange(e, "smsCode")}} id="smsCode" keyfilter="int" maxLength={6} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                    <label htmlFor="username">کد پیامک</label>
                                </FloatLabel>
                            </td>
                            <td>
                                <Button loading={saving} label="درخواست کد" onClick={()=>codeRuquest()} severity="success" iconPos="right" style={{height:"50px", width:"150px"}} />
                            </td>
                        </tr>

                        <tr>
                            <td style={{textAlign:"right"}}>

                            </td>
                        </tr>
                    </tbody>
                </table>
                <br />
            </div>
            <div style={{width:"100%", borderTop:"1px solid #b0b0b0", textAlign:"center", paddingTop:"10px"}}>
                <React.Fragment>
                    <div className="card flex justify-content-center" style={{ direction: "ltr" }}>
                        <Button loading={saving} label="ثبت درخواست عضویت معلم" icon="pi pi-check" onClick={()=>saveRequestMemberShip()} severity="success" iconPos="right" />
                    </div>
                    <br/>
                    <div>
                    <Link to="/login" style={{textDecoration:"none", color:"#a0a0a0"}}>بازگشت</Link>                
                  </div>
                </React.Fragment>
            </div>
        </div> 
        </>
        :
        <></>
        }
        <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        <Toast ref={toast} />  
        </>
    );
}
